import React from 'react';
import { Portal } from 'react-portal';
import { Progress } from 'antd';
import Close from 'common/components/svgs/Close';
import { colors } from 'common/constants/colors';

// Because of nested modals we have to create a separate Modal
const LoadingProgress = ({ title, progress, visible, onStop }) => {
  const handleClose = () => {
    onStop?.();
  };

  if (!visible) {
    return null;
  }

  return (
    <Portal>
      <div className="loading-progress__wrapper">
        <div className="loading-progress__mask" />
        <div className="loading-progress__modal">
          <div className="loading-progress__header">
            <h3 className="loading-progress__title">{title}</h3>
            <button className="loading-progress__close" onClick={handleClose}>
              <Close />
            </button>
          </div>
          <div className="loading-progress__content">
            <Progress
              percent={progress}
              width={80}
              strokeWidth={8}
              strokeColor={colors.color_keppel}
              format={percent => <span className="loading-progress__percentage">{percent}%</span>}
            />
          </div>
        </div>
      </div>
    </Portal>
  );
};

export default LoadingProgress;
